import { Download } from 'lucide-react';
import LegalPageShell from '@/components/legal/LegalPageShell';
import { legalAssets } from '@/config/legal';

export default function MinorConsentFormPage() {
  return (
    <LegalPageShell
      title="Minor's Consent Form"
      subtitle="Required if the user is under 18 years of age"
      showTermsLink
      showPrivacyLink
    >
      <div className="space-y-4 sm:space-y-6">
        <p className="text-sm sm:text-base text-gray-600">
          Please review the consent form below. You may download a copy for your records.
        </p>

        <a
          href={legalAssets.minorConsentFormPdf}
          download
          className="inline-flex items-center justify-center gap-2 px-4 py-2.5 sm:px-5 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium"
        >
          <Download className="h-4 w-4" />
          Download PDF
        </a>

        <div className="border border-gray-200 rounded-lg overflow-hidden bg-gray-100">
          <iframe
            src={legalAssets.minorConsentFormPdf}
            title="Minor Consent Form PDF"
            className="w-full h-[50vh] sm:h-[60vh] lg:h-[70vh] min-h-[320px] sm:min-h-[400px]"
          />
        </div>
      </div>
    </LegalPageShell>
  );
}
